// Remember Me functionality utilities
// Manages localStorage for login preferences

const REMEMBER_ME_KEY = 'tioassist_remember_me';
const SAVED_EMAIL_KEY = 'tioassist_saved_email';

export const rememberMeUtils = {
  // Save remember me preference and email
  saveRememberMe: (email, remember = true) => {
    try {
      localStorage.setItem(REMEMBER_ME_KEY, remember.toString());
      if (remember && email) {
        localStorage.setItem(SAVED_EMAIL_KEY, email);
      } else {
        localStorage.removeItem(SAVED_EMAIL_KEY);
      }
    } catch (error) {
      console.warn('Failed to save remember me preference:', error);
    }
  },

  // Get remember me preference
  getRememberMe: () => {
    try {
      return localStorage.getItem(REMEMBER_ME_KEY) === 'true';
    } catch (error) {
      console.warn('Failed to get remember me preference:', error);
      return false;
    }
  },

  // Get saved email
  getSavedEmail: () => {
    try {
      const remember = rememberMeUtils.getRememberMe();
      if (remember) {
        return localStorage.getItem(SAVED_EMAIL_KEY) || '';
      }
      return '';
    } catch (error) {
      console.warn('Failed to get saved email:', error);
      return '';
    }
  },

  // Clear remember me data
  clearRememberMe: () => {
    try {
      localStorage.removeItem(REMEMBER_ME_KEY);
      localStorage.removeItem(SAVED_EMAIL_KEY);
    } catch (error) {
      console.warn('Failed to clear remember me data:', error);
    }
  },

  // Check if localStorage is available
  isStorageAvailable: () => {
    try {
      const test = '__storage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }
};

export default rememberMeUtils;
